/**
 * Specifies the day type of the relative payment date offset.
 * - Tag: 40920
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const PaymentStreamPaymentDateOffsetDayType = Object.freeze({
    /** Business */
    Business: 0,
    /** Calendar */
    Calendar: 1,
    /** Commodity business */
    CommodityBusiness: 2,
    /** Currency business */
    CurrencyBusiness: 3,
    /** Exchange business */
    ExchangeBusiness: 4,
    /** Scheduled trading day */
    ScheduledTradingDay: 5,
} as const);

type PaymentStreamPaymentDateOffsetDayType =
    (typeof PaymentStreamPaymentDateOffsetDayType)[keyof typeof PaymentStreamPaymentDateOffsetDayType];
